/* eslint-disable @typescript-eslint/no-explicit-any, prefer-destructuring */

// https://developers.canny.io/install/changelog

export default function installCannySDK() {
  function loadScript() {
    if (!document.getElementById('canny-jssdk')) {
      const f = document.getElementsByTagName('script')[0];
      const e = document.createElement('script');
      e.type = 'text/javascript';
      e.async = !0;
      e.src = 'https://canny.io/sdk.js';
      if (f?.parentNode) {
        f.parentNode.insertBefore(e, f);
      }
    }
  }

  if (!window.Canny) {
    const c = function initCanny(...args: any[]) {
      c.q.push(args);
    };

    c.q = [] as any[];
    window.Canny = c;

    if (document.readyState === 'complete') {
      loadScript();
    } else if (window.attachEvent) {
      window.attachEvent('onload', loadScript);
    } else {
      window.addEventListener('load', loadScript, !1);
    }
  }
}
